import styled from '@emotion/styled';
import type { FC } from 'react';
import { Center } from '../BasicComponents/MetaComponent';
import { IconExclamation } from '../Icon';

interface Props {
  title?: string;
  subtitle?: string;
}

export const NoDataPlaceholder: FC<Props> = ({ title = 'No Data', subtitle = '' }) => {
  return (
    <Container>
      <Icon />
      <Text>{title}</Text>
      <SubText>{subtitle}</SubText>
    </Container>
  );
};

const Container = styled(Center)`
  position: relative;
  top: 30px;
  height: calc(100% - 30px);
  flex-direction: column;
  opacity: 0.4;
`;

const Icon = styled(IconExclamation)`
  font-size: 70px;
`;

const Text = styled.div`
  font-size: 2.1rem;
  margin-top: 15px;
`;

const SubText = styled.div`
  font-size: 1.2rem;
  margin-top: 5px;
`;
